import React from 'react';
import styles from './createBusiness.module.scss';
import CreateBusinessStepper from '../../Components/CeateBusinessStepper/createBusinessStepper';
import { useGeneralHooks } from '../../Hooks/hooks';
import MainLogo from '../../Components/Logos/mainLogo/mainLogo';

const CreateBusiness: React.FC = () => {
  const { largeScreen } = useGeneralHooks();

  return (
    <>
      {
        largeScreen
          ?
          <div className={styles.page}>
            <div className={styles.leftSide}>
              <CreateBusinessStepper />
            </div>
            <div className={styles.rightSide} />
          </div>
          :
          <div className={styles.mobilePage}>
            <MainLogo
              action={true}
              actionLink='/home'
            />
            <CreateBusinessStepper />
          </div>
      }
    </>

  )
}

export default CreateBusiness
